// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","3930":"164f4fb6","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","2340":"b1296ef71b0801a5","3756":"b5fa977db7bbf549","3930":"b58e139ef0764399","4316":"da7517a88118b074","5007":"c5b1d78c69cf8bef","9839":"e89876453b772dc4"}[chunkId] + ".js";
};